import { render, staticRenderFns } from "./RelatoryKeepingSector.vue?vue&type=template&id=7c0e498f&scoped=true"
import script from "./RelatoryKeepingSector.vue?vue&type=script&lang=js"
export * from "./RelatoryKeepingSector.vue?vue&type=script&lang=js"
import style0 from "./RelatoryKeepingSector.vue?vue&type=style&index=0&id=7c0e498f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0e498f",
  null
  
)

export default component.exports